import { setLoadingRedux } from "../features/commonslice";
import { logout } from "../utils/api/auth_apis";

const handleLogout = async (navigate, dispatch) => {
    dispatch(setLoadingRedux(true)); // Set loading state to true
    try {
      await logout();
  
      sessionStorage.clear();
      localStorage.clear();
  
      navigate('/login');
    } catch (error) {
      console.error('Logout failed', error);
      dispatch(setLoadingRedux(false)); // Set loading state to false in case of error
    }
  };
  
  export default handleLogout;